import { useState, useCallback, useEffect } from 'react';
import sortData from "../utils/helpers/sorter";
function useTableSorting({ updateQueryParams, getQueryParams, initialSortColumn, initialSortType }) {
  const [sortColumn, setSortColumn] = useState(initialSortColumn);
  const [sortType, setSortType] = useState(initialSortType || 'asc');

  // Initialize sort from URL parameters or use defaults
  useEffect(() => {
    const params = getQueryParams();
    if (params.sortColumn && params.sortType) {
      setSortColumn(params.sortColumn);
      setSortType(params.sortType);
    } else if (initialSortColumn && initialSortType) {
      // Set default sort if no URL params and defaults are provided
      setSortColumn(initialSortColumn);
      setSortType(initialSortType);
      
      // Update URL with default sort parameters
      updateQueryParams({
        sortColumn: initialSortColumn,
        sortType: initialSortType
      }, { replace: true });
    }
  }, [getQueryParams, initialSortColumn, initialSortType, updateQueryParams]);
  const handleSortColumn = useCallback((dataKey, newSortType) => {
    setSortColumn(dataKey);
    setSortType(newSortType);

    // Update URL with sort parameters
    const sortParams = {};
    if (dataKey && newSortType) {
      sortParams.sortColumn = dataKey;
      sortParams.sortType = newSortType;
    } else {
      sortParams.sortColumn = '';
      sortParams.sortType = '';
    }

    updateQueryParams(sortParams, { replace: true });
  }, [updateQueryParams]);

  const applySorting = useCallback((data) => {
    if (!sortColumn || !sortType || !data || data.length === 0) {
      return data;
    }
    return sortData([...data], sortColumn, sortType)
  }, [sortColumn, sortType]);

  return {
    sortColumn,
    sortType,
    handleSortColumn,
    applySorting
  };
}

export default useTableSorting;
